<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22.08 6a1.5 1.5 0 00-1.53-.74L2.9 7.85a1.5 1.5 0 00-.78 2.6L5 13v4.87a1.48 1.48 0 00.87 1.37 1.6 1.6 0 00.63.14 1.51 1.51 0 001-.37l2.15-1.84L11 18.4a1.52 1.52 0 001 .38h.11a1.52 1.52 0 001-.54l8.82-10.59A1.49 1.49 0 0022.08 6zM18.2 7.58L6.93 12.09 4.24 9.67zM7 16.83v-2l1.13 1zm4.9-.27l-4.14-3.72 10.87-4.35z"/></svg>